import Logo from '../../source/logo.png'
const Navbar = () => {
    return ( 
        <>
                <nav className="navbar navbar-dark navbar-expand-md bg-faded justify-content-center  ">
                    <div className="container">
                    <a href="/" className="navbar-brand d-flex w-50 me-auto brand_text"><img src={Logo} className="rounded" alt="logo" width="25%" height="25%" /> </a>
                     <button className="navbar-toggler first-button" type="button" data-toggle="collapse" data-target="#Menu"
                        aria-controls="navbarSupportedContent20" aria-expanded="false" aria-label="Toggle navigation">
                        <div className="animated-icon1"><span></span><span></span><span></span></div>
                    </button>
                    <div className="navbar-collapse collapse w-100" id="Menu">
                        
                        <ul className="nav navbar-nav ms-auto w-100 justify-content-end">
                        <li className="nav-item">
                            <a className="nav-link" href="#about">About</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#proyects">Proyects</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#contact">Contact</a>
                        </li>
                        
                        </ul>
                    </div>
                    </div>
                </nav>
             </>
     );
}
 
export default Navbar;